import { MouseEventHandler } from 'react'

import { ChildProps } from '@/common/util/props'

import Icon, { IconColor, IconInversion, IconType } from '@/components/view/atoms/icon/Icon'

interface Props extends ChildProps {
  link?: string
  isOpen?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const Menu = ({ children, isOpen = false, onClick }: Props) => {
  return (
    <>
      <button
        className='outline-default bg-fill-primary text-size-12 text-primary hover:bg-fill-hover active:bg-fill-active inline-flex max-w-40 items-center gap-x-2 rounded-lg p-1.5 leading-150'
        onClick={onClick}
      >
        <Icon color={IconColor.PRIMARY} size={20} type={IconType.USER_KEY} />
        <span className='truncate'>{children}</span>
        <span className='ml-auto block'>
          <Icon
            color={IconColor.PRIMARY}
            type={IconType.DOWN}
            inversion={isOpen ? IconInversion.VERTICAL : IconInversion.DEFAULT}
          />
        </span>
      </button>
    </>
  )
}

export default Menu
